<script>
import { DownloadBlobService } from '../../lib/services/downloadBlob'

export default {
  methods: {
    downloadBlob(blob, responseHeaders) {
      const fileName = DownloadBlobService.getFileNameFromContentDispositionHeader(responseHeaders['content-disposition']);
      DownloadBlobService.downloadBlob(blob, fileName);

      alert('Excel file saved. Please check your notification bar or downloads folder.')
    },
  },
}
</script>

<template>
  <div>
    <api-loader
      method="get"
      url="v1/DataAdmin/export-excel"
      response-type="blob">
      <template v-slot="{result:blob, responseHeaders}">
        <b-card>
          <b-btn @click="downloadBlob(blob, responseHeaders)">
            Download
          </b-btn>
        </b-card>
      </template>
    </api-loader>
  </div>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/views/ExcelExportView.vue